import { UserInfo } from '@microsoft/teamsfx';

import { LogSeverity } from 'src/utils/enums';
import { AppError } from 'src/errors';
import { getTeamUserProperties } from 'src/utils/utils';
import { appInsights } from './appInsights';

/**
 * Logs an exception to Azure Application Insights.
 * This function acts as a wrapper around appInsights.trackException()
 * to ensure user details are always included.
 */
export function logError<T extends AppError>(error: T, severity: LogSeverity): void {
  // Extract user from AppError if available
  let userProperties: UserInfo | undefined;

  if (error.user) {
    userProperties = getTeamUserProperties(error.user);
  }

  appInsights?.trackException({
    exception: error,
    severityLevel: severity,
    properties: {
      ...userProperties, // Ensure user properties are always included
      ...error.context,
    },
  });
}
